import { FETCH_USER, UPDATE_USER, FETCH_GRAVATAR } from "./types";
import * as userApi from "@/api-client/user";

export default {
  async fetchUser({ commit }, { onSuccess } = {}) {
    commit({
      type: FETCH_USER.request
    });

    const user = await userApi.fetchUser();

    try {
      commit({
        type: FETCH_USER.success,
        payload: user
      });

      onSuccess ? onSuccess(user) : null;
    } catch (e) {
      commit({
        type: FETCH_USER.error,
        payload: e.message
      });
    }
  },

  async updateUser({ commit }, { values, onSuccess } = {}) {
    commit({
      type: UPDATE_USER.request
    });

    try {
      const user = await userApi.updateUser(values);
      commit({
        type: UPDATE_USER.success,
        payload: user
      });

      // callback to container
      onSuccess ? onSuccess(user) : null;
    } catch (e) {
      commit({
        type: UPDATE_USER.error,
        payload: e.message
      });
    }
  },

  async fetchGravatar({ commit }, { email, onSuccess } = {}) {
    commit({
      type: FETCH_GRAVATAR.request
    });
    try {
      const gravatar = await userApi.fetchGravatar(email);
      onSuccess && onSuccess(gravatar);
      commit({
        type: FETCH_GRAVATAR.success,
        payload: gravatar
      });
    } catch (e) {
      // @eslint-ignore
      console.error("gravatar error", e);
      commit({
        type: FETCH_GRAVATAR.error,
        payload: e.message
      });
    }
  }
};
